import { Lexer, Marked, type MarkedOptions } from 'marked';

/**
 * A `Marked` instance with setext headings disabled — headings are ATX-only
 * (`#`–`#####`) in markdown-native. LLM notes never emit setext headings
 * intentionally, but `Label:` above a lone `-` bullet is a common generation
 * shape that GFM lexes as a setext H2; ATX-only keeps it a paragraph.
 */
export const createAtxOnlyMarked = (): Marked => {
  const instance = new Marked({ tokenizer: { lheading: () => undefined } });
  // `@tiptap/markdown` sub-lexes nested content (e.g. section bodies) via
  // `new instance.Lexer()` with no options, which reads marked's module
  // defaults and would skip the override — repoint it at this instance's
  // defaults. The module-level `Lexer` stays untouched.
  // The cast pins `Lexer`'s generic construct signature to the string outputs
  // this instance uses.
  instance.Lexer = class extends Lexer {
    constructor(options?: MarkedOptions<string, string>) {
      super(options ?? instance.defaults);
    }
  } as typeof Lexer;
  return instance;
};
